import {setupSettingsCommon} from "./settings_common";
import {storeNewVersion} from "../util/version";
import {mixpanel} from "../util/mixpanel";


function activateSettingsSidebar() {
    storeNewVersion();
    let is_settings_active = document.getElementById("sidebar").classList.contains("active");
    if (!is_settings_active) {
        document.getElementById("sidebar").classList.add("active");
        document.getElementById("settings_button").style.visibility = "hidden";
    }
}

async function loadModulesAsync() {
    await import('./location_autocomplete.js');
    await import('./subscription.js');
}

export function setupSettings() {
    setupSettingsCommon();
    document.getElementById("settings_button").addEventListener("click", _ => activateSettingsSidebar());
    // close sidebar
    document.getElementById("settings_close_button").addEventListener("click", _ => {
        document.getElementById("sidebar").classList.remove("active");
        document.getElementById("settings_button").style.visibility = "visible";
    });
    loadModulesAsync();
}

document.getElementById("more_settings_btn").addEventListener("click", function() {
    document.getElementById("settings_modal").classList.remove("hidden");
});

document.getElementById("settings_modal_close").addEventListener("click", function() {
    document.getElementById("settings_modal").classList.add("hidden");
});


// we remove results only on desktop on blur
document.getElementById('autocompleteInput').addEventListener('blur', function () {
    setTimeout(() => {
        document.getElementById('autocompleteResults').innerHTML = '';
    }, 200);
});